











import { Component, Vue, Prop, Watch, Emit } from 'vue-property-decorator';
import Video from './components/Video.vue'
import Hls from 'hls.js'
import { loadHlsVideo } from 'utils/index'
@Component({
  components: {
    Video
  },
})
export default class VideoContainer extends Vue {
  @Prop() private videoSource!: any

  @Prop() private isLiveStream!: boolean

  @Prop() private liveMessageShow!: boolean

  @Prop() private liveMessageTitle!: string

  @Prop() private liveMessageContent!: string
  private src = ''
}
